module.exports = __webpack_public_path__ + "static/media/zoom.d6b2444a.svg";